(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.euapplication === "undefined") {
        jQuery.extend(sm.portal.vm, { euapplication: {} });
    }

    function InitializeSections (application, coreSections) {
        var euSections = [] ;
        var languagesModel = new sm.portal.vm.LanguagesViewModel();
        var accessibilityNeedModel = new sm.portal.vm.AccessibilityNeedViewModel();
        var applicationInformationModel = new sm.portal.vm.ApplicationInformationViewModel();
        // Languages
        euSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 61,
            SectionName: 'Languages',
            SectionTitle: sm.portal.utility.getResourceValue('Languages'),
            SectionNavTitle: sm.portal.utility.getResourceValue('Languages'),
            Applied: true,
            Completed: false,
            Required: false,
            SectionModel: languagesModel,
            SectionTemplate: "LanguagesTemplate"
        }));

        // Accessibility Needs
        euSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 62,
            SectionName: 'AccessibilityNeed',
            SectionTitle: sm.portal.utility.getResourceValue('AccessibilityNeeds'),
            SectionNavTitle: sm.portal.utility.getResourceValue('Accessibility'),
            Applied: true,
            Required: false,
            SectionModel: accessibilityNeedModel,
            SectionTemplate: "AccessibilityNeedTemplate"
        }));

        // Application Information
        euSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 91,
            SectionName: 'ApplicationInformation',
            SectionTitle: sm.portal.utility.getResourceValue('ApplicationInformation'),
            SectionNavTitle: sm.portal.utility.getResourceValue('ApplicationInformation'),
            Applied: true,
            Required: false,
            Completed: true,
            SectionModel: applicationInformationModel,
            SectionTemplate: "ApplicationInformationTemplate"
        }));

        application.LastSectionName('ApplicationInformation');

        coreSections = coreSections.filter(function(e) { 
            return e.SectionName() !== 'College' &&  e.SectionName() != 'TestScore';
        });

        return coreSections.concat(euSections);
    }

    function MoveToNextSection(application, nextSectionObj){
        if (nextSectionObj != null) {
            if (application.CurrentSectionName() === "Academic") {
                var isValid = application.GetSectionModel('Academic').ValidateModel();
                if (isValid) {
                    nextSectionObj.Active(true);
                }
            }
        }
    }

    function ExtractATO(application, submitModel, stdAttempt, stdPerson){
        
        var languageSecData = application.GetSectionModel('Languages');
        var accessibilityNeedSecData = application.GetSectionModel('AccessibilityNeed');
        var applicationInformationSecData = application.GetSectionModel('ApplicationInformation');
        var basicContactSecData = application.GetSectionModel('BasicContact');

        // Construct the Language ATO object        
        submitModel.LanguagesInformation=  ko.toJS(languageSecData.ExtractATO());
        // Construct the Accessibility Need ATO object        
        submitModel.AccessibilityNeedsInformation = ko.toJS(accessibilityNeedSecData.ExtractATO());
        
        var applicationInformationData = applicationInformationSecData.ExtractATO();
        stdAttempt.AdmissionsAttemptEUAdditionalInfo.push(applicationInformationData.ApplicationInformation);

        submitModel.AdmissionsInformation = ko.toJS(stdAttempt);

        if (basicContactSecData.PermanentMailingAddress().ExtractATO() != null && basicContactSecData.showPermanentMailingAddress() === true) {
            submitModel.PersonalInformation.Addresses.push(basicContactSecData.PermanentMailingAddress().ExtractATO());
        }
        
        return submitModel;
    }


    jQuery.extend(true, sm.portal.vm.euapplication, {
        InitializeSections: InitializeSections,
        MoveToNextSection: MoveToNextSection,
        ExtractATO: ExtractATO
    });

})(jQuery);